import { useEffect } from 'react'

import useCountry from '../hooks/useCountry'
import { Outlet, useParams } from 'react-router-dom'

export default function LayoutCountry() {
  const { country_id } = useParams()
  const { getCountry } = useCountry()
  
  useEffect(() => {
    getCountry(country_id)
  }, [country_id])

  return <Outlet />
}
